import {
  MedicalResultSource,
  Result,
  isResultWithRange,
} from '../../../../../../services/MedicalResultsService';
import {
  ConfiguredRange,
  MeasurementConfig,
} from '../../../Measurements/types';
import { ResponseStats } from '../../../Measurements/useQueriedData';
import { formatLabResultDisplayForUI } from '../../../LabResults/formatters';

const toDisabledRange = <T extends string>(rangeOut: T) => {
  return {
    [rangeOut]: {
      isRangeEnabled: false,
      range: {
        lower: null,
        upper: null,
      },
    },
  } as Record<T, ConfiguredRange>;
};

export const medicalResultsMeasurementsMapper = (
  data: Result[],
  source?: MedicalResultSource,
) => ({
  dimensions: data.map((d, i) => ({
    id: d.results?.[0].resource.id ?? `${i}`,
    name: formatLabResultDisplayForUI(d.coding.display, {
      stripHcPrefix: source === 'memberUpload',
    }),
    sampling: 'last',
    codes: [
      {
        display: formatLabResultDisplayForUI(d.coding.display, {
          stripHcPrefix: source === 'memberUpload',
        }),
        system: d.coding.system,
        key: d.coding.code,
      },
    ],
    resources: d.results?.map(r => r.resource),
    enforceClinicOnly: false,
    searchAnyCodes: true,
    ...toDisabledRange('normalRange'),
    ...toDisabledRange('absoluteRange'),
    ...toDisabledRange('optimalRange'),
    snackMarkdown:
      d.results?.[0].status === 'pending'
        ? undefined
        : {
            default: '',
            normal: '',
            bad: '',
            optimal: '',
          },
  })) as MeasurementConfig['dimensions'],
  responses: data.map((d, i) => ({
    hasError: false,
    id: d.results?.[0]?.resource.id ?? `${i}`,
    subjectStats: {
      last:
        d.results?.[0]?.resource?.valueQuantity?.value ??
        d.results?.[0]?.resource?.valueString,
      lastDate: d.results?.[0]?.resource?.effectiveDateTime,
      unit: d.results?.[0]?.resource?.valueQuantity?.unit,
    },
    results: d.results.map(r => ({
      status: r.status,
      resource: r.resource,
      ranges: isResultWithRange(r) ? r.ranges : undefined,
    })),
  })) as ResponseStats[],
});
